// export const contentAPI = process.env.NODE_ENV === 'development' ? 'http://api.gotrich.test/' : 'https://api.gotrich.com/';
export const contentAPI = 'https://api.gotrich.com/';
// export const checkoutAPI = process.env.NODE_ENV === 'development' ? 'https://baron.centraqa.com/api/checkout' : 'https://baron.centra.com/api/checkout';
export const checkoutAPI = 'https://baron.centra.com/api/checkout';

// export const origin = process.env.NODE_ENV === 'development' ? 'http://localhost:3000' : 'https://gotrich.com';
export const origin = 'https://gotrich.com';

export const useLanguageURLRoots = false;

export const paymentMethodsMapping = {
	klarnaCheckout: 'klarna-checkout',
	klarnaOld: 'kreditor_v2',
	adyenCheckout: 'adyen-checkout',
	adyenDropIn: 'adyen-drop-in',
	stripeCheckout: 'stripe',
	stripePaymentIntents: 'stripe-payment-intents',
};

export const paymentMethodsOrder = [
	'klarna-checkout',
	'adyen-drop-in',
	'dibs',
	'paypal',
];

export const addressFieldOrder = [
	'identityNumber',
	'email',
	'firstName',
	'lastName',
	'company',
	'phoneNumber',
	'address1',
	'address2',
	'zipCode',
	'city',
	'state',
];

export const urlRoots = [
	'xn--gtrich-wxa',
	'götrich',
	'gotrich',
];

export const shippingMethodsMapping = {};
